import { render, staticRenderFns } from "./AdvertMask.vue?vue&type=template&id=d241653a&scoped=true"
import script from "./AdvertMask.vue?vue&type=script&lang=js"
export * from "./AdvertMask.vue?vue&type=script&lang=js"
import style0 from "./AdvertMask.vue?vue&type=style&index=0&id=d241653a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d241653a",
  null
  
)

export default component.exports